// extracted by mini-css-extract-plugin
export var button = "_nq-2";
export var card = "_nq-0";
export var closeButtonContainer = "_nq-3";
export var iconContainer = "_nq-1";